import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    token: sessionStorage.getItem('token'), //token
    oper:JSON.parse(sessionStorage.getItem('oper')),
    menus:JSON.parse(sessionStorage.getItem('menus')),
    actions:JSON.parse(sessionStorage.getItem('actions')),
    confirm:0,//token失效重复弹框问题
  },
  mutations: {
    changeConfirm(state,confirm){
      state.confirm = confirm;
    },
    // token，并将token存入sessionStorage
    changeLogin (state, token) {
      state.token = token;
      sessionStorage.setItem('token',token);
    },
    //删除token
    DeleLogin (state) {
      state.token = '';
      sessionStorage.removeItem('token');
    },
    //用户信息
    oper (state,oper){
      state.oper = oper;
      sessionStorage.setItem('oper',JSON.stringify(oper))
    },
    //删除用户信息
    DeleOper (state) {
      state.oper = '';
      sessionStorage.removeItem('oper');
    },
    //菜单树信息
    menus (state,menus){
      state.menus = menus;
      sessionStorage.setItem('menus',JSON.stringify(menus))
    },
    //删除菜单树信息
    DeleMenus (state) {
      state.menus = '';
      sessionStorage.removeItem('menus');
    },
    //操作权限
    actions (state, actions) {
      state.actions = actions;
      sessionStorage.setItem('actions',JSON.stringify(actions)) //权限信息
    },
    //删除操作权限
    DeleActions (state) {
      state.actions = '';
      sessionStorage.removeItem('actions');
    },
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js